export default "__VITE_ASSET__CvZbFFBF__"